export default __webpack_public_path__ + "static/media/expose3.833c83a1.png";